var React = require('react');

function GraduationCap48px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M48 30.946a3.002 3.002 0 0 1-3 2.996c-1.654 0-3-1.344-3-2.996 0-1.301.839-2.399 2-2.813V15.715l-7.041 4.156c.015.067.041.13.041.201v15.983a.994.994 0 0 1-.956.99c-1.449.73-6.303 2.891-13.044 2.891-6.741 0-11.596-2.161-13.044-2.891a.994.994 0 0 1-.956-.99V20.072c0-.071.026-.134.041-.201l-8.55-5.047a.997.997 0 0 1 0-1.719L22.492.119a1.003 1.003 0 0 1 1.018 0l22 12.986c.403.06.49.344.49.834v.022l.001.003-.001.004v14.165c1.162.414 2 1.512 2 2.813zM35 35.33V21.028L23.51 27.81a1.01 1.01 0 0 1-1.018 0L11 21.027V35.33c1.452.702 5.951 2.608 12 2.608 6.048 0 10.548-1.906 12-2.608zM23.001 2.139L2.966 13.964 23.001 25.79l20.034-11.826L23.001 2.139zm22.418 27.907c-.022.002-.033.016-.057.016-.138 0-.292-.036-.446-.098a.992.992 0 0 0-.916.982 1 1 0 0 0 2 0c0-.4-.24-.741-.581-.9z","key":1})]);
}

GraduationCap48px.displayName = "GraduationCap48px";

GraduationCap48px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 48 39.94"};

module.exports = GraduationCap48px;

GraduationCap48px.default = GraduationCap48px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/graduation-cap-48px.svg
// module id = 1138
// module chunks = 0